import { useEffect, useRef, useState } from "react";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import { IoIosArrowForward } from "react-icons/io";
import TrusteeFilter from "./AllFilter/TrusteeFilter";
import InstituteFilter from "./AllFilter/InstituteFilter";

function MixFilter({
  setTrusteeFilter,
  onCancel,
  onApply,
  filters,
  setFilters,
}: any) {
  const [openFilter, setOpenFilter] = useState(false);
  const [activeTab, setActiveTab] = useState(1);

  const divRef = useRef<HTMLDivElement>(null);

  const handleOutsideClick = (event: any) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setOpenFilter(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleTrusteeChange = (selected: any) => {
    setFilters((prev: any) => ({
      ...prev,
      trustee: selected,
    }));
  };

  const handleInstituteChange = (selected: any) => {
    setFilters((prev: any) => ({
      ...prev,
      institute: selected,
    }));
  };

  const handleApply = () => {
    onApply();
    setOpenFilter(false);
    setActiveTab(1);
  };

  const handleCancel = () => {
    onCancel();
    setFilters((prev: any) => ({
      ...prev,
      trustee: null,
      institute: null,
      status: null,
    }));
    setOpenFilter(false);
    setActiveTab(1);
  };

  return (
    <div className="relative w-full" ref={divRef}>
      <button
        onClick={() => {
          setOpenFilter(!openFilter);
        }}
        className="focus:outline-none border border-edviron_black hover:border-gray-300 transition-all duration-150 rounded-md py-3 px-4 w-full text-sm text-left flex items-center justify-between min-h-[44px]"
      >
        <span className="mr-2">All Filter</span>
        <HiOutlineAdjustmentsHorizontal className="w-5 h-5" />
      </button>
      {openFilter && (
        <div className="absolute right-0 text-sm bg-white min-w-[35rem] rounded-md shadow-lg z-10">
          <div className="flex gap-x-3 p-2 h-[25rem]">
            <div className="flex flex-col gap-y-4 text-xs border-r w-36 shrink-0 border-gray-500 pr-3 py-2">
              <button
                onClick={() => {
                  setActiveTab(1);
                }}
                className={
                  "flex items-center w-full rounded-full px-3 py-2 " +
                  (activeTab === 1 ? " bg-[#DADBFC]" : " ")
                }
              >
                <span>Trustee</span>
                <IoIosArrowForward className="w-4 h-4 ml-auto" />
              </button>
              <button
                onClick={() => {
                  setActiveTab(2);
                }}
                className={
                  "flex items-center w-full rounded-full px-3 py-2 " +
                  (activeTab === 2 ? " bg-[#DADBFC]" : " ")
                }
              >
                <span>Institute</span>
                <IoIosArrowForward className="w-4 h-4 ml-auto" />
              </button>
            </div>
            <div className="flex flex-col w-full h-full">
              <div className="p-4 flex flex-col h-full">
                {activeTab === 1 && (
                  <div className="w-full h-full flex flex-col">
                    <p className="text-sm font-medium mb-2">Select Trustee</p>
                    <div className="flex-1 min-h-0">
                      <TrusteeFilter
                        value={filters.trustee}
                        onChange={handleTrusteeChange}
                      />
                    </div>
                    <p className="text-xs text-gray-500 mt-2">
                      Select a trustee to filter institutes by their assigned
                      trustee
                    </p>
                  </div>
                )}
                {activeTab === 2 && (
                  <div className="w-full h-full flex flex-col">
                    <p className="text-sm font-medium mb-2">Select Institute</p>
                    <div className="flex-1 min-h-0">
                      <InstituteFilter
                        value={filters.institute}
                        onChange={handleInstituteChange}
                      />
                    </div>
                    <p className="text-xs text-gray-500 mt-2">
                      Select a institue
                    </p>
                  </div>
                )}
              </div>

              <div className="flex justify-end items-center p-4 mt-auto">
                <button
                  onClick={handleCancel}
                  className="border mr-4 px-5 py-2 rounded-md text-sm text-[#6687FF] border-edviron_black hover:bg-gray-50"
                >
                  Clear
                </button>

                <button
                  onClick={handleApply}
                  className="font-normal py-2 text-sm px-6 border text-white bg-[#1B163B] rounded-md hover:opacity-90"
                >
                  Apply Filter
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MixFilter;
